import axios from 'axios';

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/transfert`;

export const createTransfert = (data) => axios.post(`${API_BASE_URL}/create`, data);
export const saveTransfert = (payload) => axios.put(`${API_BASE_URL}/save`, payload);
export const getTransfert = (id) => axios.get(`${API_BASE_URL}/get/${id}`);
export const listTransferts = (params) => axios.get(`${API_BASE_URL}/list`, { params });
export const getItemsInTransfert = (id) => axios.get(`${API_BASE_URL}/items/${id}`);
export const addItemToTransfert = (ref, item) => axios.post(`${API_BASE_URL}/item/${ref}`, item);
export const deleteItemFromTransfert = (ref, codeArt) => axios.delete(`${API_BASE_URL}/item/${ref}/${codeArt}`);
export const validateTransfert = (id) => axios.post(`${API_BASE_URL}/validate/${id}`);
export const unvalidateTransfert = (id) => axios.post(`${API_BASE_URL}/unvalidate/${id}`);

